import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Voided transactions list - inherits from all-transactions with Voided status filter
 */
export const voidedTransactionsList: ListBuilderList = {
	id: 'default-transaction-voided',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Voided',
	type: 'default',
	active: true,
	sortOrder: 7,
	description: 'Voided transactions only',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionStatus: {
			defaultValue: [{ id: 'Voided', label: 'Voided' }],
		},
	},
};
